export default __webpack_public_path__ + "static/media/8.6772e861.jpg";